<div [ngClass]="{'bg-ric' : isFlexibleCompensation, 'linear-gradient-2' : !isFlexibleCompensation}"
  class="px-16 lg:px-40 pt-32 pb-96 md:pt-80 md:pb-72 content-bg linear-gradient-2">
  <div class="md:grid md:grid-cols-14 md:gap-x-32 place-content-center relative" *ngIf="id !== 162">
    <div class="col-span-4 md:col-span-6 md:col-start-4 inline-block md:ml-64 lg:ml-0">
      <p class="text-white font-sansMedium md:font-sans text-h600 md:text-h800">{{ 'OVERVIEW_PROJECT.CALCULATE_B' |
        translate }}</p>
    </div>
    <div class="md:col-start-11 md:col-span-1 self-center inline-block md:mr-64 lg:mr-0">
      <fun-icon [name]="'percent'" [style]="'w-[52.67px] h-[52.67px] stroke-white'"></fun-icon>
    </div>
    <div *ngIf="hasClassSelector"
      class="col-span-4 md:col-start-4 md:col-span-8 mt-16 md:mt-24 md:ml-64 lg:ml-0 flex flex-wrap items-center gap-x-12 gap-y-8">
      <span class="font-sans text-m text-cream-100">{{ classSelectorLabel }}</span>
      <div class="inline-flex flex-wrap p-4 rounded-full border border-cream-100" role="radiogroup">
        <button *ngFor="let calculatorClass of calculatorClasses" type="button" role="radio"
          [attr.aria-checked]="selectedClass?.id === calculatorClass.id" (click)="selectClass(calculatorClass)"
          class="px-12 py-4 rounded-full font-sans text-m whitespace-nowrap"
          [ngClass]="selectedClass?.id === calculatorClass.id ? 'bg-white text-eggplant-80 font-sansMedium' : 'text-white'">
          {{ calculatorClass.description }}<span *ngIf="calculatorClass.profitability != null"> · {{ calculatorClass.profitability | number:'1.0-2':'es' }}%</span>
        </button>
      </div>
    </div>
    <div class="col-span-4 md:col-start-4 mt-8 md:pt-[56px] md:ml-64 lg:ml-0">
      <p class=" font-sans text-h300 text-white pb-20 md:pb-32">{{ 'OVERVIEW_PROJECT.INTRODUCE' | translate }}</p>
      <div class="w-full flex items-center">
        <fun-input placeholder="5000" [parentForm]="cashForm" [formControlKeys]="formControlKeys"
          [errorMessages]="errorMessages" [isSubmit]="isSubmit" controlName="money" type="invest"
          [errorLogin]="errorLogin" #inputInvest classExtra="!rounded-r-none"></fun-input>
        <fun-new-button [size]="'l'" [buttonType]="inputType" (eventClick)="calculate(true)" title="{{ 'CALCULATOR.BTN' | translate }}"
          [classExtra]="' !w-full !rounded-l-none '"></fun-new-button>
      </div>
    </div>
    <div
      class="col-start-2 col-span-8 md:col-start-9 md:col-span-3 mt-20 md:mt-56 md:mr-64 lg:mr-0 py-16 px-32 border border-cream-100 rounded-lg">
      <div class="pb-16 children:font-sans children:text-l children:text-cream-100 children:inline-block">
        <p>{{ 'OVERVIEW_PROJECT.INITIAL_INV' | translate }}</p>
        <span *ngIf="!loadingCalendarInfo" class="float-right">{{ benefits.inversion | number:'1.0-0':'es' }} €</span>
        <ion-skeleton-text class="float-right" *ngIf="loadingCalendarInfo" style="width: 30%"
          animated></ion-skeleton-text>
      </div>
      <div class="pb-16 children:font-sans children:text-l children:text-cream-100 children:inline-block">
        <p>{{ 'dashboard-card.Benefits' | translate }}</p>
        <span *ngIf="!loadingCalendarInfo" class="float-right">{{ benefits.reem | number:'1.0-0':'es' }} €</span>
        <ion-skeleton-text class="float-right" *ngIf="loadingCalendarInfo" style="width: 30%"
          animated></ion-skeleton-text>
      </div>
      <div class="border border-white "></div>
      <div
        class="children:font-sans pt-16 children:text-xl children:text-white children:uppercase children:inline-block">
        <p>TOTAL </p>
        <span class="float-right" *ngIf="!loadingCalendarInfo">{{ benefits.total | number:'1.0-0':'es' }} €</span>
        <ion-skeleton-text class="float-right" *ngIf="loadingCalendarInfo" style="width: 30%"
          animated></ion-skeleton-text>
      </div>
    </div>
    <div *ngIf="hasInfo" class="col-start-2 col-span-4 md:col-start-4 pt-78 pb-24 hidden md:block md:ml-64 lg:ml-0">
      <p class="font-sans text-h600 text-white">{{ 'CALENDAR.RETURN_TIMES' | translate }}</p>
    </div>
    <div *ngIf="hasInfo" class="col-start-2 col-span-8 md:col-start-4 mt-32 md:mt-0 md:mx-32 lg:mx-0">
      <div *ngIf="period !== null && calendarInfo && calendarInfo.length > 15" class="pb-12 md:px-32 lg:px-0">
        <p class="font-sans text-xl text-cream-100">{{ 'CALENDAR.PEDIOD_TEXT' | translate }} <span class="lowercase"> {{
            period }}</span>.</p>
      </div>
      <div class="grid grid-cols-4 md:grid-cols-8 md:place-content-center py-16 children:uppercase
        children:text-white children:font-sans children:text-h100 md:children:text-h300"
        [ngClass]="{ 'md:grid-cols-10' : hasLiveCapital, 'md:grid-cols-8' : !hasLiveCapital }">
        <p class="col-span-1 col-start-1 md:col-span-2 truncate"
          [ngClass]="{ 'pl-8' : hasLiveCapital, 'pl-16' : !hasLiveCapital }">{{ 'CALENDAR.PAYMENT_DATE' | translate }}
        </p>
        <p class="col-span-1 col-start-3 md:col-span-2 pl-8 text-right truncate" *ngIf="hasLiveCapital">{{
          'CALENDAR.LIVE_CAPITAL' | translate }}</p>
        <p class="col-span-1 md:col-span-2 text-right truncate"
          [ngClass]="{ 'col-start-4 md:col-start-5 pl-8' : hasLiveCapital, 'col-start-2 md:col-start-3' : !hasLiveCapital }">
          <span *ngIf="type === 2">{{ 'CALENDAR.AVERAGE_INTEREST' | translate }}</span>
          <span *ngIf="type !== 2">{{ 'DASHBOARD.COMPONENTS.PORTFOLIO_CARD.BENEFITS' | translate }}</span>
        </p>
        <p class="col-span-1 md:col-span-2 text-right truncate"
          [ngClass]="{ 'col-start-5 md:col-start-7 pl-8' : hasLiveCapital, 'col-start-3 md:col-start-5' : !hasLiveCapital }">
          <span *ngIf="type === 2">{{ 'CALENDAR.AMORTIZATION' | translate }}</span>
          <span *ngIf="type !== 2">{{ 'CALENDAR.CAP_RETURN' | translate }}</span>
        </p>
        <p class="col-span-1 md:col-span-2 md:pr-16 text-right"
          [ngClass]="{ 'col-start-6 md:col-start-9 pl-8' : hasLiveCapital, 'col-start-4 md:col-start-7' : !hasLiveCapital }">
          Total</p>
      </div>

      <div *ngIf="hasInfo" class="rounded rounded-xl">
        <div *ngIf="hasPartialCalendar !== true">
          <div *ngFor="let item of calendarInfo; let i = index"
            class="grid md:place-content-center py-16 children:text-eggplant-80
          children:text-m md:children:text-l children:font-sans border-ocher-100 border-opacity-[0.25] border-t-[1px] bg-cream-25"
            [ngClass]="{ 'md:grid-cols-10' : hasLiveCapital, 'md:grid-cols-8' : !hasLiveCapital, 'rounded-t-xl': i === 0 }">
            <p class="col-span-2 pl-12 md:pl-16 capitalize">{{ item.period }}</p>
            <p class="col-span-2 col-start-3 text-right" *ngIf="hasLiveCapital">{{ item.liveCapital |
              number:'1.0-0':'es' }} €</p>
            <p class="text-right col-span-2"
              [ngClass]="{ 'col-start-5' : hasLiveCapital, 'col-start-3' : !hasLiveCapital }">
              <span *ngIf="!loadingCalendarInfo">{{ item.profitOrInterest | number:'1.0-0':'es'}} €</span>
              <ion-skeleton-text class="float-right" *ngIf="loadingCalendarInfo" style="width: 62px; height: 90%;"
                animated></ion-skeleton-text>
            </p>
            <p class="col-span-2 text-right"
              [ngClass]="{ 'col-start-7' : hasLiveCapital, 'col-start-5' : !hasLiveCapital }">
              <span *ngIf="!loadingCalendarInfo">{{ item.sharePremiumOrRedemption | number:'1.0-0':'es'}} €</span>
              <ion-skeleton-text class="float-right" *ngIf="loadingCalendarInfo" style="width: 62px; height: 90%;"
                animated></ion-skeleton-text>
            </p>
            <p class="col-span-2 text-right md:pr-16 pr-12"
              [ngClass]="{ 'col-start-9' : hasLiveCapital, 'col-start-7' : !hasLiveCapital }">
              <span *ngIf="!loadingCalendarInfo">{{item.amount | number:'1.0-0':'es' }} €</span>
              <ion-skeleton-text class="float-right" *ngIf="loadingCalendarInfo" style="width: 62px; height: 90%;"
                animated></ion-skeleton-text>
            </p>
          </div>
        </div>

        <div *ngIf="hasPartialCalendar === true">
          <div *ngFor="let item of partialCalendar.prev; let i = index"
            class="grid md:place-content-center py-16 children:text-eggplant-80
          children:text-m md:children:text-l children:font-sans border-ocher-100 border-opacity-[0.25] border-t-[1px] bg-cream-25"
            [ngClass]="{ 'md:grid-cols-10' : hasLiveCapital, 'md:grid-cols-8' : !hasLiveCapital, 'rounded-t-xl': i === 0 }">
            <p class="col-span-2 pl-12 md:pl-16 capitalize">{{ item.period }}</p>
            <p class="col-span-2 col-start-3 text-right" *ngIf="hasLiveCapital">{{ item.liveCapital |
              number:'1.0-0':'es' }} €</p>
            <p class="text-right col-span-2"
              [ngClass]="{ 'col-start-5' : hasLiveCapital, 'col-start-3' : !hasLiveCapital }">
              <span *ngIf="!loadingCalendarInfo">{{ item.profitOrInterest | number:'1.0-0':'es'}} €</span>
              <ion-skeleton-text class="float-right" *ngIf="loadingCalendarInfo" style="width: 62px; height: 90%;"
                animated></ion-skeleton-text>
            </p>
            <p class="col-span-2 text-right"
              [ngClass]="{ 'col-start-7' : hasLiveCapital, 'col-start-5' : !hasLiveCapital }">
              <span *ngIf="!loadingCalendarInfo">{{ item.sharePremiumOrRedemption | number:'1.0-0':'es'}} €</span>
              <ion-skeleton-text class="float-right" *ngIf="loadingCalendarInfo" style="width: 62px; height: 90%;"
                animated></ion-skeleton-text>
            </p>
            <p class="col-span-2 text-right md:pr-16 pr-12"
              [ngClass]="{ 'col-start-9' : hasLiveCapital, 'col-start-7' : !hasLiveCapital }">
              <span *ngIf="!loadingCalendarInfo">{{item.amount | number:'1.0-0':'es' }} €</span>
              <ion-skeleton-text class="float-right" *ngIf="loadingCalendarInfo" style="width: 62px; height: 90%;"
                animated></ion-skeleton-text>
            </p>
          </div>
          <div class="w-full bg-cream-25 border-ocher-100 border-opacity-[0.25] border-t-[1px]">
            <div class="flex justify-center items-center gap-6 cursor-pointer" (click)="viewAll()">
              <fun-icon [name]="'plus-circle'" [style]="'w-20 h-20 stroke-2 stroke-eggplant-80'"></fun-icon>
              <p class="font-sans py-20 text-center text-eggplant-80 text-m">{{ 'CALENDAR.LOAD_ALL' | translate }}</p>
            </div>
          </div>

          <div *ngFor="let item of partialCalendar.next; let i = index"
            class="grid md:place-content-center py-16 children:text-eggplant-80
          children:text-m md:children:text-l children:font-sans border-ocher-100 border-opacity-[0.25] border-t-[1px] bg-cream-25"
            [ngClass]="{ 'md:grid-cols-10' : hasLiveCapital, 'md:grid-cols-8' : !hasLiveCapital}">
            <p class="col-span-2 pl-12 md:pl-16 capitalize">{{ item.period }}</p>
            <p class="col-span-2 col-start-3 text-right" *ngIf="hasLiveCapital">{{ item.liveCapital |
              number:'1.0-0':'es' }} €</p>
            <p class="text-right col-span-2"
              [ngClass]="{ 'col-start-5' : hasLiveCapital, 'col-start-3' : !hasLiveCapital }">
              <span *ngIf="!loadingCalendarInfo">{{ item.profitOrInterest | number:'1.0-0':'es'}} €</span>
              <ion-skeleton-text class="float-right" *ngIf="loadingCalendarInfo" style="width: 62px; height: 90%;"
                animated></ion-skeleton-text>
            </p>
            <p class="col-span-2 text-right"
              [ngClass]="{ 'col-start-7' : hasLiveCapital, 'col-start-5' : !hasLiveCapital }">
              <span *ngIf="!loadingCalendarInfo">{{ item.sharePremiumOrRedemption | number:'1.0-0':'es'}} €</span>
              <ion-skeleton-text class="float-right" *ngIf="loadingCalendarInfo" style="width: 62px; height: 90%;"
                animated></ion-skeleton-text>
            </p>
            <p class="col-span-2 text-right md:pr-16 pr-12"
              [ngClass]="{ 'col-start-9' : hasLiveCapital, 'col-start-7' : !hasLiveCapital }">
              <span *ngIf="!loadingCalendarInfo">{{item.amount | number:'1.0-0':'es' }} €</span>
              <ion-skeleton-text class="float-right" *ngIf="loadingCalendarInfo" style="width: 62px; height: 90%;"
                animated></ion-skeleton-text>
            </p>
          </div>
        </div>

      </div>

      <div class="md:grid md:grid-cols-8 place-content-center p-16 bg-cream-100 rounded-b-lg">
        <p class="col-span-3 self-center text-eggplant-70 text-l font-sans md:pl-16">{{ 'AUTOINVEST.STEP_2.RENT_ESTIM' |
          translate }} {{ shownProfitability | number:'1.0-2':'es' }}%</p>
        <p class="col-start-6 col-span-4 font-sansMedium text-l md:text-xl text-right text-eggplant-80 pr-16 flex">{{
          'CALENDAR.FULL_REFOUND' | translate }}
          <span *ngIf="!loadingCalendarInfo" class="pl-12">{{ benefits.total | number:'1.0-0':'es' }} €</span>
          <ion-skeleton-text class="float-right pl-12" *ngIf="loadingCalendarInfo" style="width: 20%; height: 30px;"
            animated></ion-skeleton-text>
        </p>
      </div>
    </div>
    <div class="pt-64 md:pt-114 col-start-5 col-span-6">
      <p class="text-center font-sans text-white text-h600 md:text-h700 mb-24" *ngIf="status !== 3">{{
        'OVERVIEW_PROJECT.START_INV' | translate }}</p>
      <div class="block m-auto w-fit">
        <fun-overviiew-status-avatars [investors]="investors" [version]="'light'"></fun-overviiew-status-avatars>
      </div>
    </div>
    <div class="py-32 pb-96 col-span-2 col-start-7 md:pb-64 md:pb-0" *ngIf="status !== 3">
      <fun-new-button [size]="'xl'" [buttonType]="'secondary'" (eventClick)="invest()"
        title="{{ 'INVEST.INVEST' | translate }}" [classExtra]="' !w-full '" [responsive]="false"></fun-new-button>
    </div>
  </div>

  <div *ngIf="id === 162" class="max-w-[1120px] mx-auto px-16 lg:px-0">
    <p class="font-sans text-l text-white mb-32">
      *Este proyecto no cuenta con calculadora de rentabilidad, ya que los posibles retornos se presentan mediante una
      tabla de escenarios, que permite entender cómo diferentes hipótesis de precio, generación y venta de Unidades de
      Absorción pueden afectar al resultado final de la inversión.
    </p>

    <div class="border border-cream-120 rounded-xl overflow-hidden shadow-xs">
      <!-- Table Header -->
      <div class="flex bg-cream-100 py-16 px-24 border-b border-cream-120 gap-x-24 items-center">
        <p class="flex-[2] uppercase font-sans text-h300 text-eggplant-100">Escenario</p>
        <p class="flex-[5] uppercase font-sans text-h300 text-eggplant-100">Descripción</p>
        <p class="flex-[2] uppercase font-sans text-h300 text-eggplant-100 text-right">Tir Estimada</p>
      </div>

      <!-- Table Body -->
      <div class="flex flex-col bg-cream-10 divide-y divide-cream-120/25">
        <!-- Row 1 -->
        <div class="flex py-24 px-24 gap-x-24 items-center">
          <p class="flex-[2] font-sans text-m md:text-l text-eggplant-80">Net Zero 2050 (optimista)</p>
          <p class="flex-[5] font-sans text-m md:text-l text-eggplant-80">
            Escenario de transición acelerada hacia cero emisiones, con precios del carbono altos y sostenidos.
          </p>
          <p class="flex-[2] font-sans text-m md:text-l text-eggplant-80 text-right">15,50%</p>
        </div>

        <!-- Row 2 -->
        <div class="flex py-24 px-24 gap-x-24 items-center">
          <p class="flex-[2] font-sans text-m md:text-l text-eggplant-80">IETA 2°C & Delayed Transition
            (moderado)</p>
          <p class="flex-[5] font-sans text-m md:text-l text-eggplant-80">
            Escenario (1) consiguiendo limitar el calentamiento global a sólo 2°C y (2) con acción climática retrasada
            hasta 2030 y fuerte incremento posterior de precios del carbono.
          </p>
          <p class="flex-[2] font-sans text-m md:text-l text-eggplant-80 text-right">8,00%</p>
        </div>

        <!-- Row 3 -->
        <div class="flex py-24 px-24 gap-x-24 items-center">
          <p class="flex-[2] font-sans text-m md:text-l text-eggplant-80">Current Policies (pesimista)</p>
          <p class="flex-[5] font-sans text-m md:text-l text-eggplant-80">
            Escenario de políticas actuales sin refuerzo climático significativo.
          </p>
          <p class="flex-[2] font-sans text-m md:text-l text-eggplant-80 text-right">1,50%</p>
        </div>
      </div>
    </div>
  </div>


</div>